/**
 * Test IDs for GameControls component elements
 */
export const gameControlsTestIds = {
  /**
   * Test ID for the hints toggle button
   */
  hintsButton: 'game-controls-hints-button',

  /**
   * Test ID for the rulebook toggle button
   */
  rulebookButton: 'game-controls-rulebook-button',

  /**
   * Test ID for the game info button
   */
  infoButton: 'game-controls-info-button',

  /**
   * Test ID for the close game button
   */
  closeButton: 'game-controls-close-button',

  /**
   * Test ID for the play again button
   */
  playAgainButton: 'game-controls-play-again-button',

  /**
   * Test ID for the game info dialog
   */
  infoDialog: 'game-controls-info-dialog',

  /**
   * Test ID for the close game confirmation dialog
   */
  closeConfirmDialog: 'game-controls-close-confirm-dialog',

  /**
   * Test ID for the confirm close button in the dialog
   */
  confirmCloseButton: 'game-controls-confirm-close-button',

  /**
   * Test ID for the cancel button in the dialog
   */
  cancelButton: 'game-controls-cancel-button',
} as const
